/**
 * Created by jason on 2022/6/1.
 */
import React, {useState} from 'react';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect';
import useEventListener from './useEventListener';

interface WindowSize {
  width: number;
  height: number;
}

function useWindowSize(): WindowSize {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    height: 0,
    width: 0
  });
  const handleSize = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
  };
  useEventListener('resize', handleSize);
  useIsomorphicLayoutEffect(() => {
    handleSize();
  }, []);
  return windowSize;
}

export default useWindowSize;
